import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';

@Injectable({
	providedIn: 'root',
})
export class CmdbPrintQrcodeService {
	private getQrCodeCis = environment.baseApiUrl + 'load/cmdb/qrcode';
	private getBarCodeCis = environment.baseApiUrl + 'load/cmdb/barcode';

	constructor(
		private http: HttpClient,
		private AuthLoginService: AuthLoginService
	) {}

	getAllQrCodes(type: 'qrcode' | 'barcode'): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		if (type === 'qrcode') {
			return this.http.get<any>(this.getQrCodeCis, { headers: headers });
		} else if (type === 'barcode') {
			return this.http.get<any>(this.getBarCodeCis, { headers: headers });
		}
	}
}
